/**
 * @fileoverview AcceptedInvitesTable component displays accepted invites with responsive layouts.
 * Shows a table on desktop and card layout on mobile for better mobile usability.
 *
 * AcceptedInvitesTable Component
 *
 * Displays invites accepted by the user. Shows as a table on desktop and card layout on mobile.
 */
import styles from './AcceptedInvitesTable.module.css';

const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

function AcceptedInvitesTable({ acceptedInvites }) {
    if (acceptedInvites.length === 0) return null;

    return (
        <div>
            <h3 className={styles.heading}>Invites You Accepted</h3>

            {/* Desktop Table View */}
            <div className={styles.tableWrapper}>
                <table className={styles.table}>
                    <thead className={styles.tableHeader}>
                        <tr>
                            <th className={styles.tableHeaderCell}>Budget</th>
                            <th className={styles.tableHeaderCell}>Access Level</th>
                            <th className={styles.tableHeaderCell}>Accepted Date</th>
                            <th className={styles.tableHeaderCell}>Created By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {acceptedInvites.map((invite) => (
                            <tr key={invite.inviteKey} className={styles.tableRow}>
                                <td className={styles.tableCell}>{invite.budgetName}</td>
                                <td className={styles.tableCell}>
                                    {invite.accessLevel === 'member' ? 'Member' : 'Elevated Member'}
                                </td>
                                <td className={styles.tableCell}>{formatDate(invite.acceptedDate)}</td>
                                <td className={styles.tableCell}>{invite.createdByEmail}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile Card View */}
            <div className={styles.cardContainer}>
                {acceptedInvites.map((invite) => (
                    <div key={invite.inviteKey} className={styles.card}>
                        <div className={styles.cardHeader}>
                            <h5 className={styles.cardTitle}>{invite.budgetName}</h5>
                        </div>
                        <div className={styles.cardBody}>
                            <div className={styles.cardRow}>
                                <span className={styles.cardLabel}>Access Level:</span>
                                <span className={styles.cardValue}>
                                    {invite.accessLevel === 'member' ? 'Member' : 'Elevated Member'}
                                </span>
                            </div>
                            <div className={styles.cardRow}>
                                <span className={styles.cardLabel}>Accepted Date:</span>
                                <span className={styles.cardValue}>{formatDate(invite.acceptedDate)}</span>
                            </div>
                            <div className={styles.cardRow}>
                                <span className={styles.cardLabel}>Created By:</span>
                                <span className={styles.cardValue}>{invite.createdByEmail}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default AcceptedInvitesTable;
